import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "react-oauth2-code-pkce";
import { Routes, Route } from "react-router-dom";
// import { blackbaudConfig } from "./helpers/";
import { blackbaudConfig } from "./helpers/helper";
import { Provider } from "react-redux";
import store from "./store";
import history from "./helpers/history";
import { unstable_HistoryRouter as Router } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  window.location.href.includes("localhost") ? (
    <Provider store={store}>
      <Router  history={history}>
        <AuthProvider authConfig={blackbaudConfig}>
          <Routes>
            <Route path="/*" element={<App />} />
          </Routes>
        </AuthProvider>
      </Router>
    </Provider>
  ) : (
    <React.StrictMode>
      <Provider store={store}>
        <Router  history={history}>
          <AuthProvider authConfig={blackbaudConfig}>
            <Routes>
              <Route path="/*" element={<App />} />
            </Routes>
          </AuthProvider>
        </Router>
      </Provider>
    </React.StrictMode>
  )
);
